
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/var/www/projects/hillceramic.se/releases/20261105081705Z/sentry.client.config.ts")
            }
          });